import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IconUIComponent } from '../../atoms/icon/icon.component';
import { ButtonUIComponent } from '../../atoms/button/button.component';

/**
 * The full-screen filters dialog of a list or board page: a pinned header with the result count
 * and «Clear filters», a scrolling body and a pinned «Show results» button. Filters apply as they
 * change, so the button only closes the dialog.
 *
 * Body slots, top to bottom, each dropped when nothing is projected into it: `[settings]` (status
 * lines and columns), `[search]`, `[smart-filters]`, then the default slot for the column filters.
 * `fr8bot-ui-list-filters` fills it; a page doesn't use it directly.
 */
@Component({
  selector: 'fr8bot-ui-filters-dialog',
  templateUrl: './filters-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconUIComponent, ButtonUIComponent, TranslatePipe],
  host: { class: 'tw:flex tw:h-full tw:flex-col tw:bg-black tw:text-white' },
})
export class FiltersDialogUIComponent {
  readonly filtersCount = input(0);
  readonly resultsCount = input<number | null>(null);

  readonly closeDialog = output();
  readonly clearFilters = output();
}
